import { Activity, Check } from 'lucide-react'
import { useTranslation } from '@/i18n'
import { IntuiButton } from '@/components/intueri/IntuiButton'
import { useIsLiveDocument } from '@/hooks/useIsLiveDocument'
import type { StepSeries } from './liveCards'

/**
 * "Add live card" for the series a step read, shown only when the document they came from is
 * live (asked once, when the step has run). Adding twice is one card: the button then says so.
 */
export function AddLiveCard({
  series,
  added,
  onAdd,
}: {
  series: StepSeries
  added: boolean
  onAdd: (series: StepSeries) => void
}) {
  const { t } = useTranslation()
  const live = useIsLiveDocument(series.documentId, true)
  if (!live) return null
  return (
    <IntuiButton
      size="sm"
      variant="outline"
      leftIcon={added ? <Check /> : <Activity />}
      disabled={added}
      onClick={() => onAdd(series)}
    >
      {added
        ? t('workflow:builder.live_card_added', { defaultValue: 'Live card added' })
        : t('workflow:builder.live_card_add', { defaultValue: 'Add live card' })}
    </IntuiButton>
  )
}
